import React from 'react'
import classNames from 'classnames'

import ModalBody from 'components/Utils/Modal/Body'
import { Text } from 'components/base'
import ShortcutHelpers from 'helpers/ShortcutHelpers'
import ShortcutLabel from 'components/Utils/ShortcutLabel'
import {
  UndoIcon,
  RedoIcon,
  HeaderOneIcon,
  HeaderTwoIcon,
  QuoteIcon,
  BulletListIcon,
  OrderedListIcon,
  CheckboxIcon,
  CodeIcon,
  InlineCodeIcon,
  BoldIcon,
  ItalicIcon,
  UnderlineIcon,
  StrikethroughIcon,
  HighlightIcon,
  IndentIcon,
  UndentIcon,
  LinkIcon,
  EmojiIcon,
  ArobaseIcon,
  NoteIcon,
  SeparatorIcon,
  IndentedListIcon,
  SearchIcon,
  CloseIcon,
  ArrowRightIcon,
  ArrowLeftIcon,
  HorizontalArrowsIcon,
  RecycleIcon,
  NewNoteIcon,
  BurgerMenuIcon,
  InfoIcon,
  PlaceholderIcon,
  CommentsEmptyIcon,
  NewCommentIcon,
  MediaIcon,
} from 'components/Utils/Icons'

export default function Shortcuts() {
  return (
    <ModalBody className="padding-horizontal-huge padding-vertical-largest">
      <div
        className="margin-bottom-largest"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
          gridColumnGap: 80,
          gridAutoFlow: 'row dense',
        }}
      >
        <Text.Subtitle
          className="margin-bottom-normal"
          style={{ gridColumn: '1/3' }}
        >
          Editor
        </Text.Subtitle>
        <Row
          style={{ gridColumn: 1 }}
          icon={IndentedListIcon}
          title="Browse all formatting options"
          markdown="/"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={ArobaseIcon}
          title="Mention user"
          markdown="@"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={NoteIcon}
          title="Add doc link"
          markdown="@"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={UndoIcon}
          title="Undo"
          shortcut={ShortcutHelpers.undo}
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={RedoIcon}
          title="Redo"
          shortcut={ShortcutHelpers.redo}
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={BoldIcon}
          title="Bold"
          shortcut={ShortcutHelpers.toggleBold}
          symetric={true}
          markdown="*"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={ItalicIcon}
          title="Italic"
          shortcut={ShortcutHelpers.toggleItalic}
          symetric={true}
          markdown="_"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={HeaderOneIcon}
          title="Header 1"
          shortcut={ShortcutHelpers.toggleH1}
          markdown="#"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={HeaderTwoIcon}
          title="Header 2"
          shortcut={ShortcutHelpers.toggleH2}
          markdown="##"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={HeaderTwoIcon}
          title="Header 3"
          shortcut={ShortcutHelpers.toggleH3}
          markdown="###"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={CheckboxIcon}
          title="Todo list"
          shortcut={ShortcutHelpers.toggleTodo}
          markdown="[]"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={OrderedListIcon}
          title="Ordered List"
          shortcut={ShortcutHelpers.toggleOrderedList}
          markdown="1."
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={BulletListIcon}
          title="List"
          shortcut={ShortcutHelpers.toggleUnorderedList}
          markdown="-"
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={LinkIcon}
          title="Add a URL or doc link to selection"
          shortcut={ShortcutHelpers.toggleAddLink}
        />
        <Row
          icon={NewCommentIcon}
          title="Comment a selection"
          shortcut={ShortcutHelpers.toggleComment}
        />
        <Row
          icon={CommentsEmptyIcon}
          title="Quick validate a comment"
          shortcut={ShortcutHelpers.commentFastSend}
        />
        <Row
          icon={PlaceholderIcon}
          title="Placeholder"
          shortcut={ShortcutHelpers.togglePlaceholder}
        />
        <Row
          icon={InlineCodeIcon}
          title="Inline code"
          shortcut={ShortcutHelpers.toggleInlineCode}
          symetric={true}
          markdown="`"
        />
        <Row
          icon={CodeIcon}
          title="Codeblock"
          shortcut={ShortcutHelpers.toggleCodeBlock}
          symetric={true}
          markdown="```"
        />
        <Row
          icon={MediaIcon}
          title="Embed a link preview"
          shortcut={ShortcutHelpers.toggleEmbed}
          symetric={true}
        />
        <Row
          icon={QuoteIcon}
          title="Quote"
          shortcut={ShortcutHelpers.toggleQuoteBlock}
          markdown=">"
        />
        <Row
          icon={InfoIcon}
          title="Hint"
          shortcut={ShortcutHelpers.toggleHintBlock}
          markdown="!!"
        />
        <Row
          icon={UnderlineIcon}
          title="Underline"
          shortcut={ShortcutHelpers.toggleUnderline}
        />
        <Row
          icon={StrikethroughIcon}
          title="Strikethrough"
          shortcut={ShortcutHelpers.toggleStrikethrough}
          symetric={true}
          markdown="~"
        />
        <Row
          icon={HighlightIcon}
          title="Highlight"
          shortcut={ShortcutHelpers.toggleHighlight}
          symetric={true}
          markdown="::"
        />
        <Row
          icon={IndentIcon}
          title="Indent"
          shortcut={ShortcutHelpers.indentList}
        />
        <Row
          icon={UndentIcon}
          title="Undent"
          shortcut={ShortcutHelpers.undentList}
        />
        <Row icon={EmojiIcon} title="Emoji" markdown=":" />
        <Row icon={SeparatorIcon} title="Separator" markdown="---" />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
          gridColumnGap: 80,
          gridAutoFlow: 'row dense',
        }}
      >
        <Text.Subtitle
          style={{ gridColumn: '1/3' }}
          className="margin-bottom-normal"
        >
          App
        </Text.Subtitle>
        <Row
          style={{ gridColumn: 1 }}
          icon={NewNoteIcon}
          title="Create new doc"
          shortcut={ShortcutHelpers.createNote}
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={SearchIcon}
          title="Search"
          shortcut={ShortcutHelpers.toggleSearch}
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={HorizontalArrowsIcon}
          title="Quick switch"
          shortcut={ShortcutHelpers.quickSwitch}
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={SearchIcon}
          title="Search in current view"
          shortcut={ShortcutHelpers.toggleSearchInDoc}
        />
        <Row
          style={{ gridColumn: 1 }}
          icon={BurgerMenuIcon}
          title="Toggle channels list"
          shortcut={ShortcutHelpers.toggleChannelsList}
        />
        <Row
          icon={ArrowLeftIcon}
          title="Navigate backward"
          shortcut={ShortcutHelpers.navigateBackward}
        />
        <Row
          icon={ArrowRightIcon}
          title="Navigate forward"
          shortcut={ShortcutHelpers.navigateForward}
        />
        <Row
          icon={RecycleIcon}
          title="Reload page"
          shortcut={ShortcutHelpers.reloadPage}
        />
        <Row
          icon={CloseIcon}
          title="Close current panel or modal"
          shortcut={ShortcutHelpers.esc}
        />
      </div>
    </ModalBody>
  )
}

function Row({ style, icon, markdown, title, shortcut, symetric }) {
  return (
    <div
      style={style}
      className="flexbox width-full border-bottom-small border-shade-50 padding-vertical-normal flexbox-align-center"
    >
      <div className="margin-right-medium shade-30 margin-vertical-small">
        {React.createElement(icon, { size: 16 })}
      </div>
      <span
        className={classNames(
          'primary font-family-system bold',
          symetric ? '' : 'margin-right-small'
        )}
      >
        {markdown}
      </span>
      <Text.Corpus className="font-weight-medium">{title}</Text.Corpus>
      {symetric && (
        <span className="primary font-family-system bold">{markdown}</span>
      )}
      <span className="margin-left-auto flexbox">
        {shortcut && shortcut.map(key => <ShortcutLabel>{key}</ShortcutLabel>)}
      </span>
    </div>
  )
}
